function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { alignItems, borderBottom, borderRight, display } from 'styled-system';
import { Text } from '../Text';
const StyledCell = styled(Text).withConfig({
  displayName: "Cell__StyledCell",
  componentId: "sc-1qbmsz9-0"
})(["", " ", " ", " ", ""], alignItems, borderBottom, borderRight, display);
const Cell = /*#__PURE__*/React.memo(_ref => {
  let {
    alignItems = 'center',
    borderBottom = 'default',
    borderRight = 'default',
    children,
    display = 'flex',
    fontSize = 1,
    lineHeight = 1.15,
    px = 2,
    style,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledCell, _extends({
    alignItems: alignItems,
    borderBottom: borderBottom,
    borderRight: borderRight,
    display: display,
    fontSize: fontSize,
    lineHeight: lineHeight,
    px: px,
    style: style
  }, props), children);
});
Cell.propTypes = {
  ...Text.propTypes,
  ...alignItems.propTypes,
  ...display.propTypes,
  children: PropTypes.any.isRequired,
  style: PropTypes.object
};
Cell.displayName = 'Cell';
export default Cell;